/**
 * Helper per il parsing sicuro del JSON dal backend
 * Gestisce il problema delle virgolette non escapate correttamente nei campi di testo
 */

import Utils from "./utils";

/**
 * Parse sicuro di JSON dopo unescape
 * @param {string} rawResponse - Risposta raw dal backend
 * @param {string} serviceName - Nome del servizio per logging
 * @returns {any} - Oggetto/Array parsato
 */
export function safeJsonParse(rawResponse, serviceName = "unknown") {
  try {
    let unescapedResponse = Utils.unescapeString(rawResponse);

    // FIX: Le virgolette nei campi di testo (note, descrizioni, etc.)
    // non sono sempre escapate correttamente dal backend
    // Dopo l'unescape le virgolette doppie rompono il JSON
    // Esempio: "note":"ha detto "basta"" → JSON invalido

    // Pattern per trovare campi di testo comuni e fixare le virgolette al loro interno
    const textFields = [
      "note",
      "descrizione",
      "description",
      "notes",
      "commento",
      "comment",
      "messaggio",
      "message",
    ];

    textFields.forEach((field) => {
      // Trova tutti i campi con questo nome e fixa le virgolette interne
      const pattern = new RegExp(`"${field}":"(.*?)(?="[,\\}])`, "g");
      unescapedResponse = unescapedResponse.replace(pattern, (match) => {
        // Dentro il match, escapiamo tutte le virgolette tranne quelle iniziali/finali
        const fieldValue = match.substring(`"${field}":"`.length); // Rimuove "field":"
        const fixedValue = fieldValue.replace(/"/g, '\\"');
        return `"${field}":"${fixedValue}`;
      });
    });

    const result = JSON.parse(unescapedResponse);
    return result;
  } catch (error) {
    console.error(`[${serviceName}] ERRORE nel parsing JSON:`, error);
    console.error(`[${serviceName}] Raw response:`, rawResponse);

    // Fallback: prova senza unescape
    try {
      return JSON.parse(rawResponse);
    } catch (secondError) {
      console.error(`[${serviceName}] Fallback parsing fallito:`, secondError);
      throw error; // Rilancia l'errore originale
    }
  }
}

/**
 * Parse sicuro con try-catch e ritorno di array vuoto in caso di errore
 * @param {string} rawResponse - Risposta raw dal backend
 * @param {string} serviceName - Nome del servizio per logging
 * @returns {any} - Oggetto/Array parsato o array vuoto
 */
export function safeJsonParseWithFallback(
  rawResponse,
  serviceName = "unknown"
) {
  try {
    return safeJsonParse(rawResponse, serviceName);
  } catch (error) {
    console.error(
      `[${serviceName}] Impossibile parsare JSON, ritorno array vuoto`
    );
    return [];
  }
}
